/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { notificationUserConfig } from '../../config/notifications.config';
import { newUserConfig } from '../../config/newUser.config';

export interface IStaticUserPagePluginMethods extends IPluginMethodMap {
  getStaticUserPageSync(): any;
}

export class StaticUserPagePlugin implements IAgentPlugin {
  readonly methods: IStaticUserPagePluginMethods;

  constructor() {
    this.methods = {
      getStaticUserPageSync: this.getStaticUserPageSync.bind(this),
    };
  }

  getStaticUserPageSync() {
    return {
      notifications: notificationUserConfig,
      newUser: newUserConfig,
    };
  }
}
